<bx-card class="w-full min-w-fit">
  <ng-template #mainStatus>
    <span class="pr-5 text-nowrap">
      {{ 'deviceDetails.deviceStatus.title' | translate }}
    </span>

    <div class="pb-xs flex w-full flex-row items-center justify-between">
      <ng-container *ngTemplateOutlet="statusBadge; context: { $implicit: overallStatusBadge() }"> </ng-container>

      @if (muting(); as muting) {
        <div class="relative">
          <!-- TODO: Re-enable muting actions when backend supports it -->
          <!-- <button bx-button iconLeading="bell-04" size="md" type="secondary-gray" (click)="openUnmuteDialog()" [disabled]="!canMute()"> -->
          <button bx-button iconLeading="bell-04" size="md" type="secondary-gray" (click)="openUnmuteDialog()">
            {{ 'deviceDetails.deviceStatus.muting.unmuteButton' | translate }}
          </button>

          <span class="text-text-tertiary-600 absolute right-0 bottom-[-24px] text-xs font-medium text-nowrap">{{ mutingPeriod() }}</span>

          <span
            class="text-text-tertiary-600 absolute right-0 bottom-[-42px] max-w-[512px] overflow-hidden text-xs font-medium text-nowrap text-ellipsis"
            [title]="muting.reason"
          >
            {{ muting.reason }}
          </span>
        </div>
      } @else {
        <!-- TODO: Re-enable muting actions when backend supports it -->
        <!-- <button bx-button iconLeading="bell-off-03" size="md" type="secondary-gray" (click)="openMuteDialog()" [disabled]="!canMute()"> -->
        <button bx-button iconLeading="bell-off-03" size="md" type="secondary-gray" (click)="openMuteDialog()">
          {{ 'deviceDetails.deviceStatus.muting.muteButton' | translate }}
        </button>
      }
    </div>
  </ng-template>
  <bx-card-header class="mb-4 overflow-visible" [divider]="false" [title]="mainStatus"></bx-card-header>

  <div class="gap-xl pb-4xl flex w-full flex-col items-start px-7">
    <div class="gap-lg flex flex-col items-start">
      <bx-badge
        size="lg"
        type="pill-color"
        color="gray"
        iconType="dot"
        [label]="('deviceDetails.deviceStatus.since' | translate) + ': ' + (formatDate(overallActiveSince()) || 'n/a')"
        data-testid="overallSinceBadge"
      ></bx-badge>

      @for (action of overallInternalActions(); track action) {
        <bx-badge
          size="lg"
          type="pill-color"
          color="error"
          iconType="dot"
          [label]="action"
          data-testid="overallInternalActionBadge"
        ></bx-badge>
      }
    </div>

    <bx-toggle size="sm" [label]="'deviceDetails.deviceStatus.expand.all.dimensions' | translate">
      <input #bxInput type="checkbox" (change)="onExpandDimensions($event)" />
    </bx-toggle>

    @for (dimension of this.dimensions(); track $index) {
      <ng-template #accordionTitle>
        <div class="flex flex-row items-center justify-between">
          <div class="flex flex-row items-center">
            <span class="pr-5">
              {{ `deviceDetails.deviceStatus.${dimension.name}` | translate }}
            </span>

            <ng-container *ngTemplateOutlet="statusBadge; context: { $implicit: dimension.badge }"> </ng-container>
          </div>

          <ng-container *ngTemplateOutlet="activeSinceBadge; context: { $implicit: dimension.activeSince }"> </ng-container>
        </div>
      </ng-template>

      <bx-accordion class="w-full" [title]="accordionTitle" [active]="dimension.isActive">
        <div class="pt-xl grid w-full grid-cols-[repeat(6,minmax(auto,1fr))] items-center p-6">
          <div class="bxi-table-header grow-1">{{ 'deviceDetails.deviceStatus.severity' | translate }}</div>
          <div class="bxi-table-header grow-1">{{ 'deviceDetails.deviceStatus.error.message' | translate }}</div>
          <div class="bxi-table-header grow-1">{{ 'deviceDetails.deviceStatus.first.occurrence' | translate }}</div>
          <div class="bxi-table-header grow-1">{{ 'deviceDetails.deviceStatus.category' | translate }}</div>
          <div class="bxi-table-header grow-1">{{ 'deviceDetails.deviceStatus.source' | translate }}</div>
          <div class="bxi-table-header grow-1">{{ 'deviceDetails.deviceStatus.last.updated' | translate }}</div>

          <hr class="bxi-table-separator" />

          @for (subState of dimension.subStates | keyvalue; track $index) {
            @if (subState.value; as subStateValues) {
              <div class="bxi-table-cell-wrap">
                @let cardinality = subStateValues.severityInfo?.level?.cardinality;
                @if (isCardinality(cardinality)) {
                  <bxi-status-badge [cardinality]="cardinality" data-testid="statusBadgeInDimension"></bxi-status-badge>
                }
              </div>
              <div class="bxi-table-cell-wrap font-bold">{{ subStateValues.message }}</div>
              <div class="bxi-table-cell-wrap font-bold">
                {{ formatDate(subStateValues.severityInfo?.activeSince) }}
              </div>
              <div class="bxi-table-cell-wrap font-bold">{{ subState.key }}</div>
              <div class="bxi-table-cell-wrap font-bold">{{ subStateValues.source }}</div>
              <div class="bxi-table-cell-wrap font-bold">{{ formatDate(subStateValues.updatedAt) }}</div>
            }

            @if (!$last) {
              <hr class="bxi-table-separator" />
            }
          } @empty {
            <div class="p-md col-span-7 flex justify-center">
              <p>{{ 'system.no.data' | translate }}</p>
            </div>
          }
        </div>
      </bx-accordion>
    }
  </div>
</bx-card>

<ng-template #statusBadge let-badge>
  @if (badge.cardinality !== undefined) {
    @if (badge.message) {
      <bx-badge-group [content]="message" [color]="badge.color" data-testid="dimensionBadgeGroupId">
        <bxi-status-badge
          class="[&_bx-badge]:bg-bg-primary"
          data-testid="dimensionBadgeInGroupId"
          size="sm"
          [cardinality]="badge.cardinality"
        ></bxi-status-badge>
      </bx-badge-group>

      <ng-template #message>
        <div class="max-w-52 overflow-hidden text-nowrap text-ellipsis" [bxTooltip]="badge.message" data-testid="statusMessage">
          {{ badge.message }}
        </div>
      </ng-template>
    } @else {
      <bxi-status-badge data-testid="dimensionBadgeId" [cardinality]="badge.cardinality"></bxi-status-badge>
    }
  }
</ng-template>

<ng-template #activeSinceBadge let-activeSince>
  <bx-badge
    [size]="'lg'"
    [type]="'pill-color'"
    [color]="'gray'"
    [label]="('deviceDetails.deviceStatus.first.occurrence' | translate) + ': ' + (formatDate(activeSince) || 'n/a')"
    data-testid="activeSinceBadge"
  ></bx-badge>
</ng-template>
